export default __webpack_public_path__ + "static/media/info.ef64eca2.png";